import React from "react";
import { connect } from "react-redux";

import EmptyModal from "../modals/EmptyModal";
import { SnackbarData } from "../Snackbar";
import { useAuditHistoryLoader } from "../../viewmodels/audit/useAuditHistoryLoader";
import { useAuditHistoryViewModel } from "../../viewmodels/audit/useAuditHistoryViewModel";
import * as actions from "../../store/actions/index";
import type { AuditApiEntityType } from "./auditTypes";
import AuditHistory from "./AuditHistory";

type EmbeddedAuditHistoryProps = {
  entityId: number | string | null | undefined;
  entityType: AuditApiEntityType | null;
  logout: () => void;
  addSnackbar: (snackbar: SnackbarData) => void;
  enabled?: boolean;
};

function EmbeddedAuditHistory({
  entityId,
  entityType,
  logout,
  addSnackbar,
  enabled = true,
}: EmbeddedAuditHistoryProps) {
  const auditVm = useAuditHistoryViewModel(
    logout,
    entityId,
    entityType,
    addSnackbar,
  );
  const { emptyModal, setEmptyModelOpen } = auditVm;

  useAuditHistoryLoader(
    auditVm,
    enabled && Boolean(entityType && entityId),
  );

  return (
    <>
      <AuditHistory vm={auditVm} />
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </>
  );
}

const mapDispatchToProps = (dispatch: any) => ({
  addSnackbar: (snackbar: SnackbarData) =>
    dispatch(actions.addSnackbar(snackbar)),
});

export default connect(null, mapDispatchToProps)(EmbeddedAuditHistory);
